import { useAuth } from '@/store/auth';
import { QQ_APP_ID, WX_APP_ID, businessFetchTool } from './base';
import { OSNum } from '@/modules/util';

const tokenTypeMap = {
  4: 7,
  1: 4,
  2: 2,
  6: 9,
};

// 获取个人权益信息
export const getPrivilegeList = (
  successCallback: any,
  errorCallback: any,
) => {
  const { accountInfo } = useAuth.storeInfo();
  const { deviceInfo } = useAuth.storeInfo();
  const type = accountInfo.logintype === 'qq' ? 4 : 2;
  businessFetchTool(
    'GetScenesStatistics',
    {
      auth_info: {
        account_type: type,
        appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
        account_id: accountInfo.openid,
        token_type: tokenTypeMap[type],
        token: accountInfo.accessToken,
        qbid: accountInfo.qbid,
      },
      user_info: {
        guid: deviceInfo.tguid,
        qimei36: deviceInfo.qimei36,
        qua2: deviceInfo.qua2,
      },
      platform: OSNum(),
    },
    (res) => {
      res.sceneStatisticsList = [].concat(
        res.sceneStatisticsList,
      );
      successCallback(res);
    },
    errorCallback,
  );
};
